var map = {
	"./coll_1.png": 9175,
	"./coll_10.png": 5342,
	"./coll_11.png": 5043,
	"./coll_12.png": 4185,
	"./coll_13.png": 6523,
	"./coll_14.png": 7761,
	"./coll_15.png": 5980,
	"./coll_16.png": 5662,
	"./coll_2.png": 5425,
	"./coll_3.png": 1766,
	"./coll_4.png": 3971,
	"./coll_5.png": 8300,
	"./coll_6.png": 3832,
	"./coll_7.png": 2522,
	"./coll_8.png": 8885,
	"./coll_9.png": 4163
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8826;